(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lc-brand-journey"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('lc-brand-journey')) return;
    const clamp = value => Math.max(0, Math.min(1, value));
    const smooth = value => { const t = clamp(value); return t * t * (3 - 2 * t); };
    class BrandJourney extends HTMLElement {
      connectedCallback() {
        this.destroy();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.source = this.querySelector('.lc-brand__source');
        this.hero = this.closest('.hero');
        this.header = document.querySelector('#header-component');
        this.target = this.header?.querySelector('.header-logo__image-container--original img');
        if (!this.source || !this.target || !this.hero || this.dataset.enabled !== 'true' || window.Shopify?.designMode) return;
        if (!document.querySelector('#MainContent > .shopify-section')?.contains(this.hero)) return;
        if (document.querySelector('lc-brand-journey') !== this) return;
        this.schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); }); };
        const geometry = () => { this.dirty = true; this.schedule(); };
        window.addEventListener('scroll', this.schedule, { passive: true, signal });
        window.addEventListener('resize', geometry, { passive: true, signal });
        window.visualViewport?.addEventListener('resize', geometry, { passive: true, signal });
        window.addEventListener('pageshow', geometry, { signal });
        this.reduced.addEventListener('change', geometry, { signal });
        this.header.addEventListener('pointerenter', this.schedule, { signal });
        this.header.addEventListener('pointerleave', this.schedule, { signal });
        document.addEventListener('focusin', this.schedule, { signal });
        document.addEventListener('focusout', this.schedule, { signal });
        document.addEventListener('shopify:section:reorder', geometry, { signal });
        document.addEventListener('shopify:section:load', geometry, { signal });
        document.addEventListener('shopify:section:unload', geometry, { signal });
        this.mutations = new MutationObserver(this.schedule);
        this.mutations.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open', 'aria-expanded'] });
        this.resize = new ResizeObserver(geometry);
        [this, this.hero, this.header].forEach(node => this.resize.observe(node));
        const loaded = image => image.complete && image.naturalWidth ? Promise.resolve() : image.decode();
        Promise.all([loaded(this.source), loaded(this.target)]).then(() => {
          if (signal.aborted || !this.isConnected) return;
          this.flight = document.createElement('div');
          this.flight.className = 'lc-brand-flight';
          this.flight.setAttribute('aria-hidden', 'true');
          this.flight.hidden = true;
          this.light = this.source.cloneNode();
          this.dark = this.target.cloneNode();
          [this.light, this.dark].forEach(image => { image.removeAttribute('id'); image.removeAttribute('style'); image.removeAttribute('srcset'); image.removeAttribute('sizes'); image.alt = ''; image.className = ''; });
          this.light.src = this.source.currentSrc || this.source.src;
          this.dark.src = this.target.currentSrc || this.target.src;
          this.dark.className = 'lc-brand-flight__dark';
          this.flight.append(this.light, this.dark);
          document.body.append(this.flight);
          Promise.all([loaded(this.light), loaded(this.dark)]).then(() => {
            if (!signal.aborted) { this.loaded = true; geometry(); }
          }).catch(() => this.destroy());
        }).catch(() => this.destroy());
      }
      update() {
        if (!this.loaded || !this.isConnected) return;
        if (!this.header.isConnected) { this.connectedCallback(); return; }
        const body = document.body;
        if (this.reduced.matches) {
          body.classList.remove('lc-brand-ready', 'lc-brand-settled', 'lc-brand-interface');
          this.flight.hidden = true;
          this.dirty = true;
          return;
        }
        if (!body.classList.contains('lc-brand-ready')) {
          body.classList.add('lc-brand-ready');
          this.dirty = true;
        }
        const interfaceOpen = !!document.querySelector('dialog[open]') || [...document.querySelectorAll('[role="dialog"][aria-modal="true"]')].some(node => node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden') ||
          !!this.header.querySelector('details[open], [aria-expanded="true"]') || this.header.matches(':hover') || !!this.header.querySelector(':focus-visible');
        if (interfaceOpen) {
          this.wasInterface = true;
          body.classList.add('lc-brand-interface');
          this.flight.hidden = true;
          return;
        }
        if (this.wasInterface) { this.dirty = true; this.wasInterface = false; }
        const y = window.scrollY;
        if (this.dirty) {
          const rect = this.source.getBoundingClientRect();
          const hero = this.hero.getBoundingClientRect();
          this.origin = { x: rect.left, y: rect.top + y, width: rect.width, height: rect.height };
          this.start = Math.max(0, hero.top + y);
          this.distance = hero.height * Number(this.dataset.distance || 68) / 100;
          this.dirty = false;
        }
        if (!this.origin.width || !this.origin.height) {
          body.classList.remove('lc-brand-ready');
          this.flight.hidden = true;
          this.dirty = true;
          return;
        }
        const target = this.target.getBoundingClientRect();
        const header = this.header.getBoundingClientRect();
        const p = clamp((y - this.start) / Math.max(1, this.distance));
        const from = this.origin;
        const scale = 1 + (target.width / from.width - 1) * p;
        const x = from.x + (target.left - from.x) * p;
        const originY = from.y - Math.min(y, this.start);
        const travel = p + .5 * p * (1 - p);
        const top = originY + (target.top - originY) * travel;
        const solid = smooth((p - .72) / .24);
        const ink = Math.round(255 + (23 - 255) * solid);
        const settled = p >= 1 || !target.width || target.top < -header.height;
        body.classList.toggle('lc-brand-settled', settled);
        body.classList.toggle('lc-brand-interface', interfaceOpen);
        this.header.style.setProperty('--lc-header-solid', String(interfaceOpen ? 1 : solid));
        this.header.style.setProperty('--lc-header-ink', `rgb(${ink} ${ink} ${ink})`);
        this.header.style.setProperty('--lc-header-ink-rgb', `${ink} ${ink} ${ink}`);
        this.dataset.progress = p.toFixed(4);
        this.flight.style.width = `${from.width}px`;
        this.flight.style.height = `${from.height}px`;
        this.flight.style.transform = `translate3d(${x}px, ${top}px, 0) scale(${scale})`;
        this.light.style.opacity = String(1 - solid);
        this.dark.style.opacity = String(solid);
        this.flight.hidden = settled || interfaceOpen;
      }
      disconnectedCallback() { this.destroy(); }
      destroy() {
        this.controller?.abort();
        this.mutations?.disconnect();
        this.resize?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.loaded = false;
        this.flight?.remove();
        document.body.classList.remove('lc-brand-ready', 'lc-brand-settled', 'lc-brand-interface');
        ['--lc-header-solid', '--lc-header-ink', '--lc-header-ink-rgb'].forEach(name => this.header?.style.removeProperty(name));
      }
    }
    customElements.define('lc-brand-journey', BrandJourney);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lobo-home-experience"] && !Shopify.designMode) return;
  try {
    (() => {
    const body = document.body;
    if (!body.classList.contains('lobo-editorial-home')) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobile = window.matchMedia('(max-width: 767px)');
    const active = new Set();
    const observed = new WeakSet();
    const videoControllers = new Map();
    const selectors = '.lobo-featured__header, .lobo-club-story__content';
    const canAnimate = () => body.dataset.loboMotion === 'true' && !reduced.matches && !window.Shopify?.designMode;
    const animate = (element, frames, options) => {
      if (!element.animate) return;
      const animation = element.animate(frames, options);
      active.add(animation);
      animation.onfinish = animation.oncancel = () => active.delete(animation);
    };
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        observer.unobserve(entry.target);
        if (!canAnimate()) continue;
        const element = entry.target;
        const siblings = [...element.parentElement.children];
        const delay = mobile.matches || !element.matches('.hero__content-wrapper > .text-block') ? 0 : Math.min(siblings.indexOf(element), 3) * 80;
        animate(element, [{ opacity: 0, transform: `translateY(${mobile.matches ? 8 : 16}px)` }, { opacity: 1, transform: 'translateY(0)' }], {
          duration: 700, delay, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards'
        });

      }
    }, { threshold: .08 }) : null;

    function setup(root = document) {
      const category = document.querySelector('.lobo-categories');
      document.querySelectorAll('.lc-cover-scroll').forEach(link => { if (category) link.setAttribute('href', '#' + category.id); });
      if (canAnimate() && observer) {
        root.querySelectorAll(selectors).forEach(element => {
          if (observed.has(element)) return;
          observed.add(element);
          observer.observe(element);
        });
      }
      root.querySelectorAll('.hero').forEach(hero => {
        if (videoControllers.has(hero)) return;
        const videos = [...hero.querySelectorAll('video')];
        const button = hero.querySelector('.lobo-video-control');
        if (!videos.length || !button) return;
        const controller = new AbortController();
        const { signal } = controller;
        const update = () => {
          const paused = videos.every(video => video.paused);
          button.dataset.paused = String(paused);
          button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
        };
        const pause = () => { videos.forEach(video => video.pause()); update(); };
        button.hidden = false;
        button.addEventListener('click', () => {
          if (videos.some(video => !video.paused)) pause();
          else videos.forEach(video => { if (video.getClientRects().length && getComputedStyle(video.parentElement).display !== 'none') video.play().catch(update); });
        }, { signal });
        videos.forEach(video => {
          video.addEventListener('play', update, { signal });
          video.addEventListener('pause', update, { signal });
          if (reduced.matches) { video.autoplay = false; video.pause(); }
        });
        videoControllers.set(hero, { controller, pause });
        update();
      });
    }

    reduced.addEventListener('change', () => {
      if (reduced.matches) {
        observer?.disconnect();
        active.forEach(animation => animation.cancel());
        videoControllers.forEach(({ pause }) => pause());
      }
    });
    document.addEventListener('shopify:section:load', event => setup(event.target));
    document.addEventListener('shopify:section:reorder', () => setup());
    document.addEventListener('shopify:section:unload', event => {
      event.target.querySelectorAll(selectors).forEach(element => observer?.unobserve(element));
      videoControllers.forEach(({ controller }, hero) => {
        if (event.target.contains(hero)) { controller.abort(); videoControllers.delete(hero); }
      });
    });
    setup();
  })();
  } catch(e) { console.error(e); }
})();

})();
